import { useEffect, useState } from 'react';
import Banner from 'components/crm/ui/Banner';
import Button from 'components/crm/ui/Button';
import CallQualification from 'components/prospection/CallQualification';
import useText from 'hooks/useText';
import { telHref } from 'pages/prospection/callListItems';
import { getCallHistory } from 'server/crm/prospectionApi';

const EMPTY = '-';

// The call sheet: who is being called, the qualification of the call, and a
// way back to the waiting panel. Session behaviour (toast and next contact,
// pause) comes with 1397 through onConfirmed.
// history: null while loading; a failed read gives [] so that the
// qualification stays usable.
const CallSheet = ({ company, line, sessionId, onClose, onConfirmed }) => {
  const { text } = useText('prospection');
  const href = telHref(company?.phone);
  const [history, setHistory] = useState(null);
  const [confirmedMessage, setConfirmedMessage] = useState(null);
  const [reloadCount, setReloadCount] = useState(0);
  const companyId = company?.id;

  useEffect(() => {
    // An answer for a sheet closed in the meantime is ignored.
    let active = true;
    getCallHistory(companyId).then(
      (calls) => active && setHistory(calls || []),
      () => active && setHistory([]),
    );
    return () => {
      active = false;
    };
  }, [companyId, reloadCount]);

  const confirmed = ({ message, response }) => {
    setConfirmedMessage(message);
    setReloadCount((count) => count + 1);
    if (onConfirmed) onConfirmed({ message, response });
  };

  return (
    <section className="flex h-full min-w-0 flex-1 flex-col rounded-2xl border border-line bg-white">
      <div className="shrink-0 p-6 pb-4">
        <h2 className="font-title text-lg font-semibold leading-6 text-ink">
          {company?.contactName || company?.name || EMPTY}
        </h2>
        <p className="mt-1 text-sm text-muted">
          {company?.contactRole || EMPTY} · {company?.name || EMPTY} ·{' '}
          {href ? (
            <a
              href={href}
              className="text-primary underline-offset-2 hover:underline"
            >
              {company.phone}
            </a>
          ) : (
            company?.phone || EMPTY
          )}
        </p>
      </div>
      <div className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto px-6 pb-4">
        {confirmedMessage ? (
          <Banner>{confirmedMessage}</Banner>
        ) : (
          <CallQualification
            company={company}
            line={line}
            sessionId={sessionId}
            history={history}
            onConfirmed={confirmed}
          />
        )}
      </div>
      <div className="flex shrink-0 justify-end border-t border-line p-4">
        <Button variant="secondary" onClick={onClose}>
          {text('sheet.close')}
        </Button>
      </div>
    </section>
  );
};

export default CallSheet;
